import { buildUserAndPendingMessages } from './buildUserAndPendingMessages'
import { priorMessagesWithoutPending } from './priorMessagesWithoutPending'
import { regenerateInstruction } from './regenerateInstruction'

export function prepareRegenerateTurn(p) {
  const { tid, messages, exchangeId, versionIndex, nextAssistantIndex, baseText, mode } = p
  const priorMessages = priorMessagesWithoutPending({ [tid]: messages }, tid)
  const { pendingId, pendingAssistant } = buildUserAndPendingMessages({
    trimmed: '',
    exchangeId,
    versionIndex,
    assistantVersionIndex: nextAssistantIndex,
    now: Date.now(),
  })
  const apiMessages = [
    ...priorMessages.map((msg) => ({ role: msg.role, content: msg.text })),
    { role: 'user', content: `${regenerateInstruction(mode)}\n\nQuestion:\n${baseText}` },
  ]
  return { priorMessages, pendingId, pendingAssistant, apiMessages }
}
